import React, { useCallback, useState } from 'react';

import Button from '../../Button';

import { Container, Content, Header, ContentView, ButtonsView } from './styles';

type HorarioData = {
  abertura: string;
  dia: number;
  fechamento: string;
  fim: number;
  id: number;
  inicio: number;
  tempo: number;
}
type DiaData = {
  d_semana: string;
  dia: number;
  tempo: number;
}
interface ModalParams {
	id?: string;
	onClose: any;
	isVisible: boolean;
	horario: HorarioData;
	dia: DiaData;
	handleDelete: any;
}

const ModalHorarioRemove: React.FC<ModalParams> = ({
  id = 'modalHorarioRemove',
  onClose = () => {},
  isVisible,
  horario,
  dia,
  handleDelete,
}) => {
  const handleOutSideClick = useCallback(
		(e: any) => {
      if (e.target.id === id) {
        setVisible(false);

        setTimeout(() => {
          onClose();
        }, 300);
      }
    },
    [id, onClose],
  );

  const [visible, setVisible] = useState(isVisible);

  return (
    <Container id="modalHorarioRemove" onClick={handleOutSideClick}>
      <Content className={`${visible ? 'active' : ''}`}>
        <Header>
          <h1>{`${dia.d_semana} - ${horario.abertura}-${horario.fechamento}`}</h1>
        </Header>

        <ContentView>
          <h2>Deseja excluir este horário?</h2>
        </ContentView>

        <ButtonsView>
          <Button
            onClick={() => {
              setVisible(false);
              setTimeout(() => {
                onClose();
              }, 300);
            }}
            type="button"
            style={{
              backgroundColor: '#fff',
              border: '2px solid #1a83ff',
              color: '#1a83ff',
              fontSize: '18px',
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={() => handleDelete()}
            type="submit"
            style={{
              paddingRight: '50px',
              paddingLeft: '50px',
              fontSize: '18px',
            }}
          >
            Excluir
          </Button>
        </ButtonsView>
      </Content>
    </Container>
  );
};

export default ModalHorarioRemove;
